<template>
	<div>
		<div class="app__title mb-4 row">
			<div class="col">
				<h1 class="mb-1 pb-0">{{ title }}</h1>
				<div v-if="subtitle" class="text-muted font-heading text-small">{{ subtitle }}</div>
			</div>
			<div class="d-flex align-items-center justify-content-end col-sm-auto col-12">
				<slot name="button" />
			</div>
		</div>

		<slot />
	</div>
</template>

<script setup>
defineProps({
	title: String,
	subtitle: String,
})
</script>
